<!-- PDF -->
<div class="h-[100%] min-h-[600px] bg-[#f1f1f1] p-4" *ngIf="fileType === 'application/pdf'">
    <iframe [src]="safeUrl" width="100%" height="665px"></iframe>
</div>

<!-- Images -->
<div class="flex justify-center h-[665px] min-h-[600px] bg-[#f1f1f1] p-4 overflow-y-scroll" *ngIf="fileType === 'image'">
    <img [src]="safeUrl" />
</div>

<!-- Plain text and HTML -->
<div class="h-[665px] min-h-[600px] bg-[#f1f1f1] p-4 overflow-y-scroll" *ngIf="textContent && fileType.startsWith('text/')" [innerHTML]="textContent">
</div>

<!-- JSON -->
<div class="h-[665px] min-h-[600px] bg-[#f1f1f1] p-4 overflow-y-scroll" *ngIf="textContent && fileType === 'application/json'">
    <pre>{{ textContent }}</pre>
</div>

<!-- XML -->
<div class="h-[665px] min-h-[600px] bg-[#f1f1f1] p-4 overflow-y-scroll font-mono text-sm whitespace-pre-wrap break-words" *ngIf="textContent && fileType === 'application/xml'" [innerHTML]="textContent">
</div>

<!-- Excel -->
<div class="h-[665px] min-h-[600px] bg-[#f1f1f1] p-4 overflow-auto" *ngIf="textContent && fileType === 'application/vnd.ms-excel'" [innerHTML]="textContent">
</div>

<!-- DOCX -->
<div class="h-[665px] min-h-[600px] bg-[#f1f1f1] p-4 overflow-y-scroll" *ngIf="fileType === 'docx'" [innerHTML]="textContent">
</div>
